// Templates.js
import React from 'react';
import { Button } from 'primereact/button';

export const binaryPathTemplate = (rowData) => (
    rowData.binaryPath ? (
        <a href={rowData.binaryPath} target="_blank" rel="noopener noreferrer">
            <i className="pi pi-download"></i>
        </a>
    ) : null
);

export const allurePathTemplate = (rowData) => (
    rowData.allureArchive ? (
        <a href={rowData.allureArchive} target="_blank" rel="noopener noreferrer">
            <i className="pi pi-download"></i>
        </a>
    ) : null
);

export const jenkinsUrlTemplate = (rowData) => (
    rowData.jenkinsUrl ? (
        <Button
            icon="pi pi-link"
            onClick={() => window.open(rowData.jenkinsUrl, '_blank')}
            className="p-button-rounded p-button-text p-button-plain"
            tooltip="View Jenkins Job"
        />
    ) : null
);

// Add other templates as needed
